import web3 from 'web3';
import Decimal from "decimal.js";
import {CSSProperties} from "react";
import {INPUT_NUMBER_REG, INT_REG, NUMBER_REG} from "./regExp";
import {MsgStatus} from "./enum";
import {isGreaterThan} from "./number";
import DecimalTool from "./DecimalTool";
import { project } from "../contract/config";
import { ethers, utils } from "ethers";

//Parameter conversion processing
export function stringify(obj:any) {
    let str = "";
    let keys = Object.keys(obj).sort();
    keys.forEach((item, i) => {
        str += item + '=' + unescape(obj[item]) + '&'
    });
    // for (let i in obj) {
    //     if (obj.hasOwnProperty(i)) {
    //         str += i + '=' + unescape(obj[i]) + '&'
    //     }
    // }
    return str.slice(0, -1);
}

export function isUserNumber(regStr: string, str: string) {
    return new RegExp(regStr, "gi").test(str);
}

//async await Error Handling
export function awaitWrap<T>(promise: Promise<T>) {
    return promise
      .then((data:T) => [data, null])
      .catch(err => [null, err])
}

export function divDecimals(amount:any, decimals:number){
    return Decimal.div(amount.toString(), Math.pow(10, decimals));
}

export interface ITrans {
    blockHash: any
    blockNumber: any
    chainId: number
    confirmations: number
    creates: any
    data: string
    from: string
    gasLimit: any
    gasPrice: any
    hash: string
    nonce: number
    status: number,
    type: string,
    symbol: string
}
export function checkHashStatus(tranInfo: ITrans) {

    function checkStatus(currentHash:string, callback: Function) {
        // const instance = new web3(project_moonbase_loan.node);
        const instance = ethers.getDefaultProvider(project.node);
        instance.getTransactionReceipt(currentHash).then((res) => {
            if (res && res.status) {
                callback(true);
            } else if(res) {
                callback(false);
            } else {
                setTimeout(() => {
                    checkStatus(currentHash, callback);
                }, 3 * 1000);
            }
        })
    }

    return new Promise((resolve, reject) => {
        checkStatus(tranInfo.hash, (res: boolean) => {
            res ? resolve(true) : reject()
        })
    });
}

/*Formatted Address*/
export function formatAddress(address: string, start = 6, end = 4) {
    if (!address) {
        return "";
    }
    let reg = new RegExp(`(.{${start}}).+(.{${end}}$)`, "g");
    return address.replace(reg, "$1...$2")
}
/*Determine safari browser*/
const isSafari = () => {
    return /Apple/.test(navigator.vendor);
};
/*Time Formatting*/
export function formatDate(dateStr:string|number, format:string="yyyy/MM/dd hh:mm:ss") {
    if (!dateStr) {
        return "";
    }
    // @ts-ignore
    if (isSafari() && isNaN(dateStr)) {
        dateStr = String(dateStr).replace(/(\d{2})(\d{2})$/, "$1:$2");
    }
    if (/^\d+$/g.test(String(dateStr))) {
        dateStr = Number(dateStr)
    }
    let dateObejct = new Date(dateStr);
    let date:any = {
        "M+": dateObejct.getMonth() + 1,
        "d+": dateObejct.getDate(),
        "h+": dateObejct.getHours(),
        "m+": dateObejct.getMinutes(),
        "s+": dateObejct.getSeconds(),
        "q+": Math.floor((dateObejct.getMonth() + 3) / 3),
        "S+": dateObejct.getMilliseconds()
    };
    if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (dateObejct.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (let k in date) {
        if (date.hasOwnProperty(k)) {
            if (new RegExp("(" + k + ")").test(format)) {
                format = format.replace(RegExp.$1, RegExp.$1.length === 1
                  ? date[k] : ("00" + date[k]).substr(("" + date[k]).length));
            }
        }
    }
    return format;
}

export function formatDuring(time: number) {
    let days: string | number = Math.floor(time / (1000 * 60 * 60 * 24));
    let hours: string | number = Math.floor(time % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    let minutes: string | number = Math.floor(time % (1000 * 60 * 60) / (1000 * 60));
    let seconds: string | number = Math.floor(time % (1000 * 60) / 1000);

    if (days < 10) {
        days = '0' + days
    }
    if (hours < 10) {
        hours = '0' + hours
    }
    if (minutes < 10) {
        minutes = '0' + minutes
    }
    if (seconds < 10) {
        seconds = '0' + seconds
    }
    return days + ' days ' + hours + ':' + minutes + ':' + seconds;
}

export function getInput(amount: number | string, decimal: number) {
    return utils.parseUnits(String(amount), decimal);
}

export const fixedNumber = (value:number|string, precision:number = 0) => {
    if (!value) {
        return 0;
    }
    //let scale = String(Number(value)*Math.pow(10, precision));
    // return parseInt(scale)/Math.pow(10, precision);
    let scale = Decimal.mul(value, Math.pow(10, precision)).toFixed();
    return Decimal.div(parseInt(scale), Math.pow(10, precision)).toNumber() ;
};

/*with, separating numbers*/
export function formatNumber(value: number|string, splitor = ",") {
    if (typeof value !== "number" && typeof value !== "string") {
        return "-";
    }
    let amount = Math.abs(Number(value));
    if (amount > 1000) {
        let numAry = String(amount).split('.');
        let numStr = numAry[0].split("").reverse().join("");
        let length = numStr.length;
        let newStr = numStr.replace(/\d{3}/gi, function(a, b){
            if (b/3 + 1 < Math.ceil(length/3)) {
                return a + splitor;
            } else {
                return a;
            }
        });
        newStr = newStr.split("").reverse().join("") + (numAry[1]?`.${numAry[1]}`:'');
        return Number(value) < 0 ? `-${newStr}` : newStr;
    }
    return String(value);
}

export function formatUSDT(amount: string | number | undefined | null, decimals?: number, rounding: Decimal.Rounding = 1) {
    if (typeof amount === "undefined" || amount === null) {
        return "-";
    }
    return formatNumber(fixedNumberStr(amount, decimals || 2, rounding));
}

export function isNumber(str: string) {
    return new RegExp(NUMBER_REG, "gi").test(str);
}
export function isIntNumber(str: string) {
    return new RegExp(INT_REG, "gi").test(str);
}
export const fixedNumberStr = (value:number|string|undefined, precision:number = 0, rounding: Decimal.Rounding = 1) => {
    if (typeof value === "undefined") {
        return "-";
    }
    if (typeof value !== "number" && !isNumber(String(value))) {
        return "-";
    }

    let scale = Decimal.mul(value, Math.pow(10, precision)).toFixed(0, rounding);
    let valStr = Decimal.div(parseInt(scale), Math.pow(10, precision)).toFixed();
    return valStr;
};

export function formatLocalFullDate(date:string|number) {
    return new Date(date).toLocaleString()
}
export function formatLocalDate(date:string|number) {
    return new Date(date).toLocaleDateString()
}
export function formatLocalTime(date:string|number) {
    return new Date(date).toLocaleTimeString()
}
